import { createGlobalStyle } from "styled-components";
// import "antd/dist/antd.min.css";
// import "react-phone-number-input/style.css";
// import "react-toastify/dist/ReactToastify.css";
// import "leaflet/dist/leaflet.css";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {

    @media(max-width: 1080px) {
      font-size: 93.75%;
    }

    @media(max-width: 720px) {
      font-size: 87.5%;
    }
  }

  html, body, #root {
    height: 100%;
  }

  /* body {
    font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: ${({ theme }) => `${theme.colors.darkWhite}`};
  } */

  button, svg {
    cursor: pointer;
  }

  /* a:hover {
    color: ${({ theme }) => theme.colors.transactionPrimary} !important;
  } */

  ::-webkit-scrollbar {
    width: 2px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 20px;
    border: 3px solid ${({ theme }) => theme.colors.primary};
  }

  input[type=number]::-webkit-inner-spin-button { 
    -webkit-appearance: none;
    
  }

  input[type=number] { 
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

export default GlobalStyles;
